import { render, staticRenderFns } from "./ListStats.vue?vue&type=template&id=2409239f"
import script from "./ListStats.vue?vue&type=script&lang=js"
export * from "./ListStats.vue?vue&type=script&lang=js"
import style0 from "./ListStats.vue?vue&type=style&index=0&id=2409239f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports